import "./App.css";
import { InitController } from "./game/script/scene/InitController";

function App() {
  return <InitController />;
}

export default App;
